import { classNames } from "repoV2/utils/common/render/classNames";
import React from "react";
import { IPaymentSummary } from "../../IPaymentSummary";
import styles from "./BillSummary.module.scss";
import commonStyles from "../../../commonStyles.module.scss";
import ExpandButton from "../ExpandButton";

const BillSummary = ({
    isMobile,
    eventCurrencySymbol,
    showBillSummaryConditionalLabel,
    billSummaryConditionalLabel,
    toggleIsPaymentSummaryExpanded,
    totalPrice,
    showStrikedOutPrice,
    strikedOutPrice,
    billSummaryLabel,
    expandButtonProps,
    disablePaymentSummaryExpanding,
}: IPaymentSummary.IBillSummaryProps) => {
    return (
        <div
            className={classNames(
                "w-100",
                !disablePaymentSummaryExpanding && "pointer"
            )}
            onClick={toggleIsPaymentSummaryExpanded}
        >
            <div className={styles.billLine}>
                <strong
                    className={classNames(
                        isMobile
                            ? styles.billItem
                            : commonStyles.sidebarSectionTitle,
                        "d-flex justify-content-between align-items-center"
                    )}
                >
                    <div>
                        {billSummaryLabel}
                        {showBillSummaryConditionalLabel ? (
                            <div className={styles.reviewSmallText}>
                                {billSummaryConditionalLabel}
                            </div>
                        ) : null}
                    </div>
                    <div className={styles.priceCol}>
                        <div>
                            <span>{eventCurrencySymbol}</span>
                            &nbsp;
                            {totalPrice}
                            {showStrikedOutPrice ? (
                                <>
                                    &nbsp;
                                    <del>
                                        {/* This will show the price that would be for all upsell items 
                                            included if early bird on base listing wasn't active */}
                                        <span>{eventCurrencySymbol}</span>
                                        {strikedOutPrice}
                                    </del>
                                </>
                            ) : null}
                        </div>
                        {!isMobile ? null : (
                            <ExpandButton {...expandButtonProps} />
                        )}
                    </div>
                </strong>
                {!isMobile ? <ExpandButton {...expandButtonProps} /> : null}
            </div>
        </div>
    );
};

export default BillSummary;
